import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { EnderecoAPI } from '@/api/sit-pedidos/endereco.api';

const api = new EnderecoAPI();

const findByZipCode = (
  zipcode: string
): AxiosObservable<any> => api.findByZipCode(zipcode);

const listAllStates = (): AxiosObservable<any> => api.listAllStates();

const listAllCities = (): AxiosObservable<any> => api.listAllCities();

const listAllDistrictsByCityId = (
  cityId: number
): AxiosObservable<any> => api.listAllDistrictsByCityId(cityId);

export default { findByZipCode, listAllStates, listAllCities, listAllDistrictsByCityId };
